import { AnimatePresence, motion } from 'framer-motion';

import { MatchCardV3 } from '@/components/MatchCardV3/MatchCardV3';
import { MatchPropsShort } from '@/modules/results/types';
import { MatchExtended } from '@/modules/ticker/types';
import { formatMatchInfoSnakeCase } from '@/utils/helpers/formatMatchInfoSnakeCase';

export interface MatchCardModalWrapperProps {
  matches?: MatchPropsShort;
  setOpenMatchUUID: React.Dispatch<React.SetStateAction<string>>;
}

const MatchCardModalWrapper = ({ matches, setOpenMatchUUID }: MatchCardModalWrapperProps) => {
  if (!matches) return null;

  const duoMatch = matches && matches.team_one_player_two_uuid;
  const formattedResults: MatchExtended[] = formatMatchInfoSnakeCase({
    matchInfos: [matches],
    imagesWidth: duoMatch ? 80 : 100,
    imagesHeight: duoMatch ? 80 : 100,
    matchCardType: 'MATCHV3',
  });

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}
        onClick={() => setOpenMatchUUID('')}
      >
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={(e) => e.stopPropagation()}
          className='h-auto w-[592px]'
        >
          {formattedResults.map((result) => (
            <MatchCardV3 key={result.id} match={result} />
          ))}
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default MatchCardModalWrapper;
